// extracted by mini-css-extract-plugin
export var footer = "_il-0";
export var inherit = "_il-1";
export var input = "_il-2";
export var modalContent = "_il-3";
export var quillEditor = "_il-4";
export var subtitle = "_il-5";